
import ContainerLayout from '@/components/Layout/ContainerLayout';
import { Paper } from '@/components/Paper';
import { useEffect, useRef, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import headers, { mockData, mockLogisticaDataDetailed } from './settings';
import { useFetchList } from './service';
import { Spinner, Box, IconButton, HStack, Icon } from '@chakra-ui/react';
import { WrapperTable } from '@/components/WrapperTable';

import DashboardResumo from './Components/Resume';
import TabelaLogistica from './Components/TabelaLogistica';
import FooterAction from './Components/FooterAction';
import { AddIcon } from '@chakra-ui/icons';
import { MdFilterList } from 'react-icons/md';
import FilterCarga from './children/Form';
import Header from '@/components/components/Header';

function AcompanhamentoAgendamento() {
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [visibleHeaders, setVisibleHeaders] = useState(headers);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [acompanhamento, setAcompanhamento] = useState<any>("Todos");
  const [dataTable, setDataTable] = useState<any[]>(mockData);
  const nav = useNavigate();
  const printRef = useRef(null);

  const [filters, setFilters] = useState({
    ativo: true,
    predio: "",
    andar: "",
    apartamento: "",
    rua: "",
    tipo: undefined,
  });

  const { data, isLoading } = useFetchList({
    page: currentPage - 1,
    size: 20,
    totalCount: 0,
    search: {},
  });
  useEffect(() => {

    if (acompanhamento === "Todos") {
      setDataTable(mockData);
    } else {
      setDataTable(mockLogisticaDataDetailed);
    }
  }, [acompanhamento]);


  const handleCardClick = (label: string) => {
    setAcompanhamento(label)
  };

  const handleFilterChange = (data: any) => {
    setFilters(data);
    setCurrentPage(1);
  };

  return (
    <ContainerLayout>
      <Box w={'100%'} justifyContent={'center'} alignContent={'center'}>
        <DashboardResumo onClick={handleCardClick} />
      </Box>
      <Paper
        m={6}
        bg="white"
        py={4}
        px={2}
        rounded="xl"
        shadow="sm"
        border="1px solid rgba(200, 200, 200, .4)"
        h={'94%'}
      >
        <Header
          onHeadersChange={setVisibleHeaders}
          isFilterVisible={isFilterVisible}
          headers={visibleHeaders}
          isMenuEnabled
          onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
          onView={() => console.log('Visualizar ação executada')}
          printRef={printRef}
          title={'Acompanhamento de Portaria Agendamento'}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          management
          filterComponent={
            <FilterCarga onFilter={handleFilterChange}>
              <Icon as={MdFilterList} boxSize={6} cursor="pointer" />
            </FilterCarga>
          }
        />

        <WrapperTable ref={printRef}>
          {isLoading ? (
            <Box py={10} textAlign="center">
              <Spinner size="lg" />
            </Box>
          ) : (
            <>
              <HStack p={1} pt={2} justifyContent="flex-end">
                <IconButton
                  aria-label="Add"
                  icon={<AddIcon />}
                  onClick={() => nav('novo')}
                  colorScheme="green"
                  size="sm"
                  borderRadius="full"
                />
              </HStack>
              <TabelaLogistica maxHeight='500px' type={acompanhamento} data={dataTable} />

            </>
          )}
        </WrapperTable>
        <FooterAction />
        <Outlet />

      </Paper>
    </ContainerLayout>
  );
}

export default AcompanhamentoAgendamento;
